
export function hostLink() {
  // return "www.hhpoker777.com"
  // return "http://192.168.9.69:8080/"
  return [
    {
      id: "1",
      // url: "192.168.9.69:8080",
      url: "www.hhpoker777.com",
      // text: "https://www.hpoker111.com/"
      describe1: "domainLinks.text1",
      describe2: "domainLinks.text3",
      describe3: "domainLinks.text4",
      // bg1: "../../hhpoker/domain-bg1-m.png",
      bg1: "../../hhpoker/domain-bg1",
      bg2: "../../hhpoker/domain-bg2",
    },
  ]
}

export function domainLinks() {
  return [
    {
      id: "1",
      url: "https://www.hpoker111.com/",
      text: "https://www.hpoker111.com/"
    },
    {
      id: "2",
      url: "https://www.hpoker222.com/",
      text: "https://www.hpoker222.com/"
    },
    {
      id: "3",
      url: "https://www.puke666hh.com/",
      text: "https://www.puke666hh.com/"
    },
    {
      id: "4",
      url: "https://www.puke777hh.com/",
      text: "https://www.puke777hh.com/"
    },
    {
      id: "5",
      url: "https://www.puke888hh.com/",
      text: "https://www.puke888hh.com/"
    },
    {
      id: "6",
      url: "https://www.puke999hh.com/",
      text: "https://www.puke999hh.com/"
    },
  ]
}
